import http from '../http'

export default {
  index: async () => {
    const { data } = await http.get('/api/private/v1/in-page-skin-groups')
    return data.data
  }
}
